import { updateColumnWidths } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/section-widths/actions.tsx';
import type { DispatchProps } from './types.tsx';

const mapDispatchToProps: DispatchProps = {
	updateTopLevelColumnWidths: updateColumnWidths,
};

export default mapDispatchToProps;
